//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { Opaque } from '@utils/opaque';

type FacebookPageId = Opaque<string, 'FacebookPageId'>;

function FacebookPageIdFactory(facebookPageId: string) {
  return facebookPageId as FacebookPageId;
}

const FacebookPageId = FacebookPageIdFactory;

export default FacebookPageId;
